export class ApiKeyManager {
    private static instance: ApiKeyManager;
    private apiKey: string | null;

    private constructor() {
        this.apiKey = null;
        this.loadFromEnvironment();
    }

    public static getInstance(): ApiKeyManager {
        if (!ApiKeyManager.instance) {
            ApiKeyManager.instance = new ApiKeyManager();
        }
        return ApiKeyManager.instance;
    }

    private loadFromEnvironment(): void {
        try {
            let envApiKey: string | undefined;
            try {
                envApiKey = process.env.OPENAI_API_KEY;
            } catch {
                // process not defined (browser without DefinePlugin)
            }
            if (envApiKey) {
                this.apiKey = envApiKey;
            }
        } catch (error) {
            this.apiKey = null;
        }
    }

    public getApiKey(): string | null {
        return this.apiKey;
    }

    public setApiKey(apiKey: string): void {
        this.apiKey = apiKey;
    }

    public hasApiKey(): boolean {
        return !!this.apiKey;
    }

    public getRequiredApiKey(): string | null {
        const apiKey = this.getApiKey();

        let envApiKey: string | undefined;
        try {
            envApiKey = process.env.OPENAI_API_KEY;
        } catch {
            // process not defined (browser without DefinePlugin)
        }
        if (!apiKey && envApiKey) {
            throw new Error(
                'OPENAI_API_KEY environment variable is set but no API key was loaded. ' +
                    'This indicates a test environment configuration issue. ' +
                    'Please check your test setup.',
            );
        }

        return apiKey;
    }
}

/**
 * Gets API key based on environment - uses API key when available (tests),
 * returns null for production (session auth).
 */
export function getApiKeyForEnvironment(): string | null {
    // If OPENAI_API_KEY env var is set, we're in test environment - use API key auth
    let hasEnvApiKey = false;
    try {
        hasEnvApiKey = !!process.env.OPENAI_API_KEY;
    } catch {
        // process not defined (browser without DefinePlugin)
    }
    if (hasEnvApiKey) {
        const apiKeyManager = ApiKeyManager.getInstance();
        return apiKeyManager.getApiKey();
    }

    // In production, rely on session auth (no API key needed)
    return null;
}
